import { immerable } from "immer";
import { CurrencyPriceInfos } from "./currency-price-infos";
import { DbMongoBaseInfos } from "./db-mongo-base-infos";

export class DbOrderManualTaskServiceInfos extends DbMongoBaseInfos {
  [immerable] = true;
  platformId: number | null = 0;
  createdByUserId: number | null = 0;
  createdDate: Date | null = null;
  name: string | null = null;
  description: string | null = null;
  erpCode: string | null = null;
  groupIds: number[] | null = null;
  createdByUserName: string | null = null;

  prices?: CurrencyPriceInfos[] | null = null;
  serviceId?: number | null = 0;

  constructor(init?: Partial<DbOrderManualTaskServiceInfos>) {
    super();
    Object.assign(this, init);
  }
}
